/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isNil from 'lodash/isNil';
import merge from 'lodash/merge';

import CommunicatorSchedule from '../communicator/schedule/communicator-schedule';
import CommunicatorUtility from '../communicator/utility/communicator-utility';

/**
 * Komunikátor playlistů pro Ki-Wi Server.
 */
class PlaylistCommunicator {
  /**
   * @param {TrackCommunicator} trackCommunicator
   */
  constructor(trackCommunicator) {
    this.trackCommunicator = trackCommunicator;
  }

  /**
   * Zpracuje seznam playlistů a zanořených modelů.
   * @param {Array.<Object>} jsonArray Část odpovědi na obsah zařízení se seznamem playlistů.
   * @returns {DsMap} Mapa datových atributů ke vložení do datového skladu.
   */
  parseMany(jsonArray) {
    return CommunicatorUtility.parseMany(
      jsonArray,
      (json) => this.parseOne(json),
      { playlist: {}, track: {} }
    );
  }

  /**
   * Zpracuje jeden playlist bez zanořených modelů.
   * @param {Object} json Část odpovědi na obsah zařízení s jedním playlistem.
   * @param {DsId} [id] Identifikátor playlistu, který se má zpracovat.
   * @returns {DsAttrs} Obsah playlistu ke vložení do datového skladu.
   */
  parseModel(json, id) {
    return {
      id,
      scheduleEnum: CommunicatorSchedule.parse(json.scheduler.type),
      volume: CommunicatorUtility.parseVolume(json.volume)
    };
  }

  /**
   * Zpracuje jeden playlist a zanořené modely.
   * @param {Object} json Část odpovědi na obsah zařízení s jedním playlistem.
   * @returns {DsMap} Mapa datových atributů ke vložení do datového skladu.
   */
  parseOne(json) {
    const { id } = json;
    if (isNil(id)) {
      return { playlist: {}, track: {} };
    }
    const playlistModel = this.parseModel(json, id);
    const playlistMap = { playlist: { [id]: playlistModel } };
    const trackMap = this.trackCommunicator.parseMany(json.tracks, id);
    return merge({}, trackMap, playlistMap);
  }
}

export default PlaylistCommunicator;
